export default "__VITE_ASSET__CnxpbJg5__"